import { render, staticRenderFns } from "./DealArgonInfo.vue?vue&type=template&id=1ad663f9&"
import script from "./DealArgonInfo.vue?vue&type=script&lang=js&"
export * from "./DealArgonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports